"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _isFinite = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-finite"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _WarningYellowOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/WarningYellowOutline"));

var _utils = require("../lib/utils");

var _icon = _interopRequireDefault(require("../icon/icon"));

var _bouncer = _interopRequireDefault(require("../bouncer/bouncer"));

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _textTruncate = _interopRequireDefault(require("./textTruncate"));

require("./labelValue.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context4, _context5; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(source), !0)).call(_context4, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var SummaryValue = function SummaryValue(_ref) {
  var value = _ref.value,
      truncateValue = _ref.truncateValue,
      truncateLines = _ref.truncateLines,
      showMoreButton = _ref.showMoreButton,
      tooltipConfig = _ref.tooltipConfig;

  if (truncateValue && (0, _utils.isString)(value)) {
    return /*#__PURE__*/_react["default"].createElement(_textTruncate["default"], {
      key: value,
      text: value,
      tooltipConfig: tooltipConfig,
      lines: truncateLines,
      showMoreButton: showMoreButton
    });
  }

  return value;
};

var getContainer = function getContainer(type, labelValueContainer, primaryIcon, alignIcon) {
  var _context;

  if ((0, _includes["default"])(_context = ["primary", "secondary", "tertiary"]).call(_context, type)) {
    if (alignIcon === "right") {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, labelValueContainer, primaryIcon);
    }

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, primaryIcon, labelValueContainer);
  }

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, labelValueContainer);
};

var getLabelContainer = function getLabelContainer(label, align, labelClass) {
  return label && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.gatherClasses)(null, "oui-lv-row", "oui-lv-label", "oui-lv-horizontally-align-".concat(align), labelClass)
  }, (0, _utils.isFunction)(label) ? label() : label) || "";
};

var getPrimaryIcon = function getPrimaryIcon(type, icon) {
  var _context2;

  if ((0, _includes["default"])(_context2 = ["primary", "secondary", "tertiary"]).call(_context2, type) && icon) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "oui-lv-col oui-lv-primary-icon"
    }, /*#__PURE__*/_react["default"].isValidElement(icon) ? /*#__PURE__*/_react["default"].cloneElement(icon, {
      className: (0, _utils.gatherClasses)(null, "oui-lv-icon", icon.props.className),
      muted: false
    }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({
      size: "md"
    }, _objectSpread(_objectSpread({}, icon), {}, {
      classes: "".concat(icon.classes && "".concat(icon.classes, " oui-lv-icon") || ""),
      muted: false
    }))));
  }

  return "";
};

var getLabelValueContainer = function getLabelValueContainer(type, labelHtml, valueHtml, align) {
  var tempHtml = "";

  switch (type) {
    case "summary":
      tempHtml = /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, labelHtml, valueHtml);
      break;

    case "primary":
    case "secondary":
    case "tertiary":
      tempHtml = /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, valueHtml, labelHtml);
      break;

    default:
      break;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-lv-col oui-lv-label-value-container oui-lv-horizontally-align-".concat(align)
  }, tempHtml);
};

var getValueContainer = function getValueContainer(type, value, unit, icon, align, alignIcon, renderValue, data) {
  var isLoading = data.isLoading,
      isError = data.isError;
  var iconHtml = "";
  var unitHtml = "";
  var valueFullWidth = false;
  var loaderOrError = null;

  if (isLoading || isError) {
    if (isLoading) {
      loaderOrError = /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-mt-1"
      }, /*#__PURE__*/_react["default"].createElement(_bouncer["default"], {
        gray: true
      }));
    }

    if (isError) {
      loaderOrError = /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-mt-1"
      }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        text: "Error loading data"
      }, /*#__PURE__*/_react["default"].createElement(_WarningYellowOutline["default"], null)));
    }
  }

  switch (type) {
    case "summary":
      iconHtml = icon && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-lv-summary-icon"
      }, /*#__PURE__*/_react["default"].isValidElement(icon) ? /*#__PURE__*/_react["default"].cloneElement(icon, {
        className: (0, _utils.gatherClasses)(null, "oui-lv-icon", icon.props.className),
        muted: false
      }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], _objectSpread(_objectSpread({}, icon), {}, {
        classes: "".concat(icon.classes && "".concat(icon.classes, " oui-lv-icon") || ""),
        muted: false
      }))) || "";
      break;

    case "primary":
    case "secondary":
    case "tertiary":
      unitHtml = unit && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-lv-unit"
      }, unit) || "";
      break;

    default:
      break;
  }

  if (type === "summary" && (align === "left" && (!icon || icon && alignIcon !== "right") || align === "right" && (!icon || icon && alignIcon === "right"))) {
    valueFullWidth = true;
  }

  var showBarlowFont = type !== "summary" && !(0, _utils.isFunction)(renderValue) && (0, _isFinite["default"])(Number(value));

  var valueHtml = /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("oui-lv-value", {
      "oui-lv-value-number": showBarlowFont
    }),
    style: valueFullWidth ? {
      width: "100%"
    } : {}
  }, (0, _utils.isFunction)(renderValue) ? renderValue(data) : type === "summary" ? /*#__PURE__*/_react["default"].createElement(SummaryValue, {
    value: value,
    truncateValue: data.truncateValue,
    truncateLines: data.truncateLines,
    showMoreButton: data.showMoreButton,
    tooltipConfig: data.tooltipConfig
  }) : value), unitHtml);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-lv-row oui-lv-value-container oui-lv-horizontally-align-".concat(align)
  }, alignIcon === "right" ? loaderOrError !== null ? loaderOrError : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, valueHtml, iconHtml) : loaderOrError !== null ? loaderOrError : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, iconHtml, valueHtml));
};

var LabelValue = function LabelValue(props) {
  var _context3;

  var label = props.label,
      labelClass = props.labelClass,
      value = props.value,
      unit = props.unit,
      type = props.type,
      icon = props.icon,
      align = props.align,
      alignIcon = props.alignIcon,
      renderValue = props.renderValue,
      dataTestId = props.dataTestId;
  var valueContainer = getValueContainer(type, value, unit, icon, align, alignIcon, renderValue, props);
  var labelContainer = getLabelContainer(label, align, labelClass);
  var labelValueContainer = getLabelValueContainer(type, labelContainer, valueContainer, align);
  var primaryIcon = getPrimaryIcon(type, icon);
  var container = getContainer(type, labelValueContainer, primaryIcon, alignIcon);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, (0, _concat["default"])(_context3 = "oui-label-value-container oui-lv-".concat(type, " oui-lv-horizontally-align-")).call(_context3, align))
  }, container);
};

LabelValue.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  labelClass: _propTypes["default"].string,
  renderValue: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  unit: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "summary"]),
  icon: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    classes: _propTypes["default"].string
  }),
  align: _propTypes["default"].oneOf(["left", "center", "right"]),
  alignIcon: _propTypes["default"].oneOf(["left", "right"]),
  className: _propTypes["default"].string,
  truncateValue: _propTypes["default"].bool,
  truncateLines: _propTypes["default"].number,
  showMoreButton: _propTypes["default"].bool,
  tooltipConfig: _propTypes["default"].shape({
    placement: _propTypes["default"].oneOf(["auto", "top", "right", "bottom", "left"]),
    textAlign: _propTypes["default"].oneOf(["left", "center", "right"]),
    maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    customRenderer: _propTypes["default"].func
  }),
  dataTestId: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  isError: _propTypes["default"].bool
};
LabelValue.defaultProps = {
  label: "",
  labelClass: "",
  value: "-",
  type: "summary",
  align: "left",
  alignIcon: "left",
  truncateValue: false,
  truncateLines: 3,
  showMoreButton: true,
  tooltipConfig: {},
  dataTestId: "orion-label-value",
  isLoading: false,
  isError: false
};
LabelValue.displayName = "OrionLabelValue";
var _default = LabelValue;
exports["default"] = _default;